module.exports = __webpack_public_path__ + "img/banner-dex-point.d2880f2e.webp";